import { CustomerUserDetailPage } from "@/features/customer-user/pages/CustomerUserDetailPage";

const CustomerUserDetail = () => {
  return <CustomerUserDetailPage />;
};

export default CustomerUserDetail;
